const formatPrice = (price) => (price === 0 ? 0 : price ? price / 100 : "");

export default formatPrice;
